// SPDX-License-Identifier: Elastic-2.0
/**
 * OnboardingGuard (T-004).
 *
 * Redirects to `/onboarding` when `localStorage["onboarding-complete"]`
 * is not the string `"true"`. The flag is written at the end of A6
 * (functional spec § 3.8) and cleared by Settings → "Reset onboarding"
 * (functional spec § 7).
 *
 * The imperative check lives in `onboardingState.ts` so router loaders
 * and other non-React code can call it without importing JSX.
 */
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "./routes";
import { isOnboardingComplete } from "./onboardingState";

export function OnboardingGuard(): JSX.Element {
  if (!isOnboardingComplete()) {
    return <Navigate to={ROUTES.ONBOARDING} replace />;
  }
  return <Outlet />;
}
